import { ourStaff } from './our-staff/our-staff.module';
import { inTheNews } from './in-the-news/in-the-news.module';

import { AboutUsService } from './about-us.service';

import './about-us.scss';

export const aboutUs = angular
	.module('components.aboutUs', [
		ourStaff,
		inTheNews
	])
	.service('AboutUsService', AboutUsService)
	.name;



// WEBPACK FOOTER //
// ./src/app/components/about-us/about-us.module.js